import React, { useCallback, useEffect } from 'react';
import SearchBar from '../../../elements/SearchBar/SearchBar3';
import { useDirectoryTagCategories } from '../../../../data/hooks/directory/useDirectoryTagCategories';
import { useDirectoryFilter } from '../../../../data/hooks/directory/useDirectoryFilter';
import { useDispatch } from 'react-redux';
import SearchBarFilterSelection from '../../../elements/SearchBarFilterSelection/SearchBarFilterSelection';
import { useDirectorySubItems } from '../../../../data/hooks/directory/useDirectorySubItems/useDirectorySubItems';

function DirectorySearchBar(props) {
    const { event, item, onOpenFilterScreen } = props,
        availableTags = useDirectoryTagCategories(event.id, item.id),
        filterParams = useDirectoryFilter(event.id, item.id),
        hasSubItems = useDirectorySubItems(event.id, item.id).length > 0,
        dispatch = useDispatch();

    const handleFilterTextChange = useCallback((text) => dispatch(app.actions.directoryFilter.setDirectoryFilter(event.id, item.id, { text })), [event.id, item.id]),
        handleToggleFavorites = useCallback(
            () => dispatch(app.actions.directoryFilter.setDirectoryFilter(event.id, item.id, { favorites: !filterParams.favorites })),
            [event.id, item.id, filterParams.favorites]
        );

    const handleRemoveTag = useCallback(
            (tag, option) => {
                const nextFilterParams = {
                    ...filterParams,
                    tags: {
                        ...(filterParams.tags ?? {}),
                        [tag]: (filterParams.tags[tag] ?? []).filter((optionName) => optionName !== option.name),
                    },
                };
                dispatch(app.actions.directoryFilter.setDirectoryFilter(event.id, item.id, nextFilterParams));
            },
            [event.id, item.id, filterParams]
        ),
        handleClearFilter = useCallback(() => {
            const nextFilterParams = {
                ...filterParams,
                tags: {},
            };
            dispatch(app.actions.directoryFilter.setDirectoryFilter(event.id, item.id, nextFilterParams));
        }, [event.id, item.id, filterParams]);

    if (!item.is_directory) return null;
    if (!hasSubItems) return null;

    return (
        <SearchBar
            value={filterParams.text || ''}
            favorites={filterParams.favorites}
            onFilterClick={onOpenFilterScreen}
            disableFilterButton={!availableTags?.length}
            onTextChange={handleFilterTextChange}
            showEditIcon={filterParams.tags?.length}
            onToggleFavorites={handleToggleFavorites}>
            <SearchBarFilterSelection tags={availableTags} selectedTags={filterParams.tags} onRemoveTag={handleRemoveTag} onClearFilter={handleClearFilter} />
        </SearchBar>
    );
}

export default DirectorySearchBar;
